__turbopack_context__.v({
  "className": "oMvF5a_className",
  "variable": "oMvF5a_variable",
});
